import { Button, ListItemText, MenuItem, MenuList, Popover, styled, Typography } from '@material-ui/core';
import * as coreSelectors from 'core/selectors';
import React, { useRef, useState } from 'react'
import { connect } from 'react-redux'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import { useHistory } from 'react-router-dom';
import * as coreActions from 'core/actions';
import Confirm from 'ui/Confirm';

const StyledButton = styled(Button)(({ theme }) => ({
    '& .MuiButton-label': {
        color: 'black'
    },

    textTransform: 'none',
    textShadow: 'none',
    borderWidth: 2,
    borderRadius: 50,
    fontFamily: 'Sofia',
    textDecoration: 'none',
    color: 'black'
}))

function ProfileDropdown({ user, logout, setDrawerOpen, buttonStyles = {} }) {
    const userButtonRef = useRef(null)
    const history = useHistory()
    const [userMenuOpen, setUserMenuOpen] = useState(false)
    const [confirmLogout, setConfirmLogout] = useState(false)


    return (
        <>
            <Confirm
                open={confirmLogout}
                title="Are you sure you want to log out?"
                confirmLabel='Logout'
                onConfirm={() => logout()}
                onCancel={() => setConfirmLogout(false)}
            />

            <StyledButton
                ref={userButtonRef}
                variant='text'
                onClick={() => setUserMenuOpen(true)}
            >
                <Typography variant='body2' style={{ fontFamily: 'Sofia', color: 'black', ...buttonStyles }}>Hello,&nbsp;</Typography>
                <Typography variant='body2' style={{ fontFamily: 'Sofia', color: 'black', ...buttonStyles }}>{user.firstName}</Typography>
                <ArrowDropDown />
            </StyledButton>
            <Popover anchorEl={userButtonRef.current}
                anchorOrigin={{
                    horizontal: 'center',
                    vertical: 'bottom'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={userMenuOpen}
                onClose={() => setUserMenuOpen(false)}>

                <MenuList>
                    <MenuItem
                        onClick={() => {
                            history.push('/profile');
                            setDrawerOpen && setDrawerOpen(false);
                            setUserMenuOpen(false);
                        }}>
                        <ListItemText style={{ fontFamily: 'Sofia' }}>
                            <span style={{ fontFamily: 'Sofia' }}>My Profile</span>
                        </ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            window.open("https://www.ruby.com");
                            setUserMenuOpen(false);
                        }}>
                        <ListItemText style={{ fontFamily: 'Sofia' }}>
                            <span style={{ fontFamily: 'Sofia' }}>www.ruby.com</span>
                        </ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            setUserMenuOpen(false)
                            setConfirmLogout(true)
                        }}>
                        <ListItemText>
                            <span style={{ fontFamily: 'Sofia' }}>Logout</span>
                        </ListItemText>
                    </MenuItem>
                </MenuList>
            </Popover>



        </>
    )
}

const mapStateToProps = (state) => {
    return ({
        user: coreSelectors.getUser(state),
    });
};

const mapDispatchToProps = {
    logout: coreActions.logout
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDropdown);